// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import moment from 'moment';
import { BookitupNotification } from '../../../../Types/LogT';
import { RoutingS } from '../../../../Service/RoutingS';
import LinkText from '../../../../Atoms/LinkText';

const RequestReceived: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { eventId, eventDate, personDescription } = notification;

  if (!eventDate) {
    return (
      <Text>
        <LinkText span weight="bolder" onClick={() => RoutingS.openInNewTab(`/events/${eventId}/details`)}>
          Neue Anfrage
        </LinkText>{' '}
        ohne Datum von
        <Text span weight="bolder">
          {` ${personDescription}`}.
        </Text>
      </Text>
    );
  }

  return (
    <Text>
      Neue Anfrage für den{' '}
      <LinkText span weight="bolder" onClick={() => RoutingS.openInNewTab(`/events/${eventId}/details`)}>
        {eventDate && `${moment(eventDate).format('LL')}`}
      </LinkText>
      .
    </Text>
  );
};

export default RequestReceived;
